import React, { useState, useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import { Button, Checkbox, Chip, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { BackgroundSelector } from './BackgroundSelector';
import { flowBgKindLabel } from './flowBgAssetsUi';

export const BackgroundNode = ({ data }) => {
  const [selectorOpen, setSelectorOpen] = useState(false);

  const handleSelect = useCallback(
    (payload) => {
      data.onChange?.(payload);
      setSelectorOpen(false);
    },
    [data]
  );

  const handleRemove = useCallback(() => {
    data.onChange?.({
      backgroundImageId: null,
      backgroundImageUrl: null,
      backgroundThumbnailUrl: null,
      backgroundAssetKind: null
    });
  }, [data]);

  const hasImage = Boolean(data.backgroundImageId);

  return (
    <div className="react-flow__node-default">
      <Handle
        type="target"
        position={Position.Left}
        style={{
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />

      <div className="condition-label">
        <label style={{ display: 'block' }}>Background</label>
      </div>

      <div style={{ padding: 20, paddingTop: 0, maxWidth: 280 }}>
        {hasImage ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'stretch' }}>
            <BoxImage src={data.backgroundThumbnailUrl || data.backgroundImageUrl} />
            <Chip
              size="small"
              label={`${flowBgKindLabel(data.backgroundAssetKind === 'slide' ? 'slide' : 'background')} · ${String(data.backgroundImageId).slice(-8)}`}
              onDelete={handleRemove}
              color="secondary"
              sx={{ alignSelf: 'flex-start', maxWidth: '100%' }}
            />
          </div>
        ) : (
          <Button variant="contained" color="secondary" onClick={() => setSelectorOpen(true)}>
            Select image
          </Button>
        )}

        <div style={{ marginTop: 14, width: '100%' }}>
          <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5, fontWeight: 600 }}>
            Start effects
          </Typography>
          <FormGroup sx={{ gap: 0 }}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={Boolean(data.effectShake)}
                  onChange={(e) => data.onChange?.({ effectShake: e.target.checked })}
                />
              }
              label="Shake"
              sx={{ mr: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={Boolean(data.effectFadeBlack)}
                  onChange={(e) => data.onChange?.({ effectFadeBlack: e.target.checked })}
                />
              }
              label="FadeBlack"
              sx={{ mr: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }}
            />
          </FormGroup>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="default"
        style={{
          right: 0,
          top: '72%',
          transform: 'translateY(-50%)'
        }}
      />

      <BackgroundSelector open={selectorOpen} onClose={() => setSelectorOpen(false)} onSelect={handleSelect} />
    </div>
  );
};

function BoxImage({ src }) {
  if (!src) return null;
  return (
    <div
      style={{
        borderRadius: 8,
        overflow: 'hidden',
        border: '1px solid rgba(255,255,255,0.12)',
        maxHeight: 120,
        background: 'rgba(0,0,0,0.2)'
      }}
    >
      <img src={src} alt="" style={{ width: '100%', height: '100%', maxHeight: 120, objectFit: 'cover', display: 'block' }} />
    </div>
  );
}
